import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, } from "@fortawesome/free-solid-svg-icons";
import { FileContainer, IconContainer, ImageContainer } from "./styles";
import { getPictureSources } from "../../lib/utils/helpers";
import { Picture } from "react-responsive-picture";

export const Thumbnail = ({ item, itemUrl, onItemClick, thumbnailCursor }: any) => {
  if (item?.assetComponent?.asset.length !== 1) return <></>;
  const altText = item?.assetComponent?.asset[0].altText || '';
  const posterImageUrl = item?.posterImage?.asset && item?.posterImage?.asset.length > 0 ? item?.posterImage?.asset[0].url : '';
  if (item.mediaType === 'image') {
    return <ImageContainer $cursor={thumbnailCursor} className="mb-2" href={itemUrl} onClick={e => onItemClick(e, item.id)}>
      <Picture sources={getPictureSources(item?.assetComponent?.asset[0])} alt={altText} />
    </ImageContainer>
  }
  if (item.mediaType === 'logo' || item.mediaType === 'infographic') {
    return <FileContainer $cursor={thumbnailCursor} className="mb-2" href={itemUrl} onClick={e => onItemClick(e, item.id)}>
      <Picture sources={getPictureSources(item?.assetComponent?.asset[0])} alt={altText} />
    </FileContainer>
  }
  if ((item.mediaType === 'video' || item.mediaType === 'document') && posterImageUrl?.length > 0) {
    return <ImageContainer $cursor={thumbnailCursor} className="mb-2" href={itemUrl} onClick={e => onItemClick(e, item.id)}>
      <img src={posterImageUrl} alt={altText} />
    </ImageContainer>
  }
  // default
  return <IconContainer className="mb-2" href={itemUrl} onClick={e => onItemClick(e, item.id)}>
    <FontAwesomeIcon icon={faInfoCircle} size="3x" />
  </IconContainer>

}